import type { ReactNode } from "react";

import { createContext, useState } from "react";

import type { MediaItem } from "./mediaPreviewModal.types";

import { MediaPreviewModal } from "./index";

interface MediaPreviewModalContextType {
  closeModal: () => void;
  isOpen: boolean;
  mediaItems: MediaItem[];
  openModal: (itemId: string) => void;
  selectedItemId?: string;
  setMediaItems: (mediaItems: MediaItem[]) => void;
}

export const MediaPreviewModalContext = createContext<
  MediaPreviewModalContextType | undefined
>(undefined);

export function MediaPreviewModalProvider({
  children,
  usePreview = true,
}: {
  children: ReactNode;
  usePreview?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>();
  const [mediaItems, setMediaItems] = useState<MediaItem[]>([]);

  const openModal = (itemId: string) => {
    setSelectedItemId(itemId);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <MediaPreviewModalContext.Provider
      value={{
        closeModal,
        isOpen,
        mediaItems,
        openModal,
        selectedItemId,
        setMediaItems,
      }}
    >
      {children}

      {isOpen && (
        <MediaPreviewModal
          alt=""
          currentItemId={selectedItemId}
          mediaItems={mediaItems}
          onClose={closeModal}
          usePreview={usePreview}
        />
      )}
    </MediaPreviewModalContext.Provider>
  );
}
